import { render, staticRenderFns } from "./UserAccountAdmin.vue?vue&type=template&id=67b9fb04&"
import script from "./UserAccountAdmin.vue?vue&type=script&lang=js&"
export * from "./UserAccountAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports